const { calculateDistancePriority } = require("../calculator/calculateDistancePriority");
const moment=require('moment');
const { DISTANCE_LIMITS, TIME_CONSTANTS } = require("../constants");
const { realRouteDistance } = require("../realRouteDistance");

/**
 * Belirtilen aracın ve siparişin ardışık olup olmadığını kontrol eder.
 * @param {Object} vehicle - Kontrol edilecek araç bilgisi.
 * @param {number} vehicle.latitude - Aracın mevcut enlemi.
 * @param {number} vehicle.longitude - Aracın mevcut boylamı.
 * @param {Object} vehicle.planning - Araç planlama bilgisi.
 * @param {number} vehicle.planning.taskCounter - Araç üzerindeki iş sayısı.
 * @param {number} vehicle.planning.state - Araç durumunu belirten kod.
 * @param {number} vehicle.targettLat - Aracın hedef enlemi.
 * @param {number} vehicle.targettLng - Aracın hedef boylamı.
 * @param {number} vehicle.outpointLat - Aracın çıkış noktası enlemi.
 * @param {number} vehicle.outpointLng - Aracın çıkış noktası boylamı.
 * @param {Array<string>} vehicle.orderNos - Araç üzerindeki sipariş numaraları listesi.
 * 
 * @param {Object} order - Kontrol edilecek sipariş bilgisi.
 * @param {number} order.startLat - Siparişin başlangıç noktası enlemi.
 * @param {number} order.startLng - Siparişin başlangıç noktası boylamı.
 * @param {number} order.endLat - Siparişin bitiş noktası enlemi.
 * @param {number} order.endLng - Siparişin bitiş noktası boylamı.
 * @param {string} order.orderNo - Sipariş numarası.
 * @param {Date} order.deliveryDate - Siparişin teslim tarihi.
 * 
 * @returns {boolean} - Aracın belirtilen siparişi ardışık olarak alıp alamayacağını döndürür.
 */
function isSequential(vehicle, order) {
  const vehiclePlate = vehicle.vehicle || vehicle.plate;
 
  // Sadece spesifik araç için detaylı log
  if (vehiclePlate === '27AGJ583' && order.orderNo === '44868') {
    console.log('🔄 [27AGJ583] isSequential başladı:', {
      vehicle: vehiclePlate,
      orderNo: order.orderNo,
      taskCounter: vehicle?.planning?.taskCounter,
      orderNos: vehicle?.orderNos,
      state: vehicle?.planning?.state,
      hasReservations: vehicle?.allReservations?.length
    });
  }

  let betweenPlanningDistance = 0;
  let orderDistance = 0;
  let remainingMinuteForSecondOrder = 0;

  // Rezervasyon sistemi için: allReservations varsa onu kullan, yoksa taskCounter
  const actualJobCount = vehicle?.allReservations?.length || vehicle?.planning?.taskCounter || 0;

  // Sadece rezervasyonlu araçlar için log

  if (actualJobCount == 1) {
    betweenPlanningDistance = calculateDistancePriority(
      { startLat: Number(vehicle.targettLat), startLng: Number(vehicle.targettLng) },
      { latitude: Number(order.startLat), longitude: Number(order.startLng) }
    );

    orderDistance = calculateDistancePriority(
      { startLat: Number(order.startLat), startLng: Number(order.startLng) },
      { latitude: Number(order.endLat), longitude: Number(order.endLng) }
    );

    let estimatedArrivalMinutes = 0; // Aracın mevcut konumundan 1.işini bitereceği tahmini süre

    if (vehicle?.planning.state > 4) {
      // Aracın mevcut konumundan teslimat noktasına tahmini varış süresi
      estimatedArrivalMinutes =
        (calculateDistancePriority(
          { startLat: Number(vehicle.latitude), startLng: Number(vehicle.longitude) },
          { latitude: Number(vehicle.targettLat), longitude: Number(vehicle.targettLng), }
        ) /
          TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED  // Ortalama hız
      estimatedArrivalMinutes + TIME_CONSTANTS.UNLOADING_TIME; //Boşaltma tahliyesi eklemesi
    } else if (vehicle?.planning.state < 5) {
      // Aracın mevcut konumundan Önce Yüklemeye oradan teslimat noktasına tahmini varış süresi
      const estimatedFillinglMinutes =
        (calculateDistancePriority(
          { startLat: Number(vehicle.latitude), startLng: Number(vehicle.longitude) },
          { latitude: Number(vehicle.outpointLat), longitude: Number(vehicle.outpointLng) }
        ) /
          TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED;

      // Aracın mevcut konumundan teslimat noktasına tahmini varış süresi
      const estimatedeliveryMinutes =
        (calculateDistancePriority(
          { startLat: Number(vehicle.latitude), startLng: Number(vehicle.longitude) },
          { latitude: Number(vehicle.targettLat), longitude: Number(vehicle.targettLng) }
        ) /
          TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED;

      estimatedArrivalMinutes = estimatedFillinglMinutes + estimatedeliveryMinutes + (TIME_CONSTANTS.LOADING_TIME + TIME_CONSTANTS.UNLOADING_TIME) // Yükleme ve boşaltma tahliye süreside eklendi
    }

    // 2.işin teslim süresinden 1. iş  için haracanak süre çıkarılır ve 2. iş için kalan vakit bulunur
    remainingMinuteForSecondOrder = moment(order.deliveryDate).diff(
      moment().add(estimatedArrivalMinutes, "minutes"),
      "minutes"
    );
  }

  if (!Array.isArray(vehicle?.orderNos)) {
    vehicle.orderNos = [];
  }

  // Rezervasyon sisteminden gelen orderNos'ları kullan (daha güncel)
  const reservationOrderNos = vehicle?.allReservations?.map(r => r.orderNo) || [];
  const actualOrderNos = reservationOrderNos.length > 0 ? reservationOrderNos : vehicle.orderNos;


  const result = (
    actualOrderNos.length == 0 ||
    (
      (actualJobCount == 1 && // araçta sadece 1 spot iş olacak (rezervasyondan)
        actualOrderNos.filter((r) => r != order.orderNo).length == 1) && // aracın seçilen siparişten 1 farklı işi olmalı
      (DISTANCE_LIMITS.SEQUENTIAL_MAX_DISTANCE - betweenPlanningDistance >= 0 && // 100 km uzaklığa göre işi bitmek üzere olan araçlar gelebilir.
        remainingMinuteForSecondOrder > //2.sipariş için kalan süre
        ((orderDistance / TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED + (TIME_CONSTANTS.LOADING_TIME + TIME_CONSTANTS.UNLOADING_TIME)))) //2. sipariş için gerekli olan mesafe süresi artı tahliye süresi (30+30)
  );


  return result;
  // Araç üzerinde bir spot iş olabilir.

  //Siparişin teslim tarihinin diğer işin teslim tarihi farkı,
  //Bana lazım olan hedeflenen süreden küçük olmalı.
  //Ve bunu dakika cinsinden hesaplıyoruz.
}







// ==================================== Sequential With RealRoute

/**
 * Belirtilen aracın ve siparişin ardışık olup olmadığını kontrol eder.
 * @param {Object} vehicle - Kontrol edilecek araç bilgisi.
 * @param {number} vehicle.latitude - Aracın mevcut enlemi.
 * @param {number} vehicle.longitude - Aracın mevcut boylamı.
 * @param {Object} vehicle.planning - Araç planlama bilgisi.
 * @param {number} vehicle.planning.taskCounter - Araç üzerindeki iş sayısı.
 * @param {number} vehicle.planning.state - Araç durumunu belirten kod.
 * @param {number} vehicle.targettLat - Aracın hedef enlemi.
 * @param {number} vehicle.targettLng - Aracın hedef boylamı.
 * @param {number} vehicle.outpointLat - Aracın çıkış noktası enlemi.
 * @param {number} vehicle.outpointLng - Aracın çıkış noktası boylamı.
 * @param {Array<string>} vehicle.orderNos - Araç üzerindeki sipariş numaraları listesi.
 * 
 * @param {Object} order - Kontrol edilecek sipariş bilgisi.
 * @param {number} order.startLat - Siparişin başlangıç noktası enlemi.
 * @param {number} order.startLng - Siparişin başlangıç noktası boylamı.
 * @param {number} order.endLat - Siparişin bitiş noktası enlemi.
 * @param {number} order.endLng - Siparişin bitiş noktası boylamı.
 * @param {string} order.orderNo - Sipariş numarası.
 * @param {Date} order.deliveryDate - Siparişin teslim tarihi.
 * 
 * @returns {boolean} - Aracın belirtilen siparişi ardışık olarak alıp alamayacağını döndürür.
 */
async function isSequentialWithRealRoute(vehicle, order ) {

  let betweenPlanningDistance = 0;
  let orderDistance = 0;
  let remainingMinuteForSecondOrder = 0;

  // Rezervasyon sistemi için: allReservations varsa onu kullan, yoksa taskCounter
  const actualJobCount = vehicle?.allReservations?.length || vehicle?.planning?.taskCounter || 0;

  // Sadece rezervasyonlu araçlar için log

  if (actualJobCount == 1) {
   
       betweenPlanningDistance = await realRouteDistance(
        { lat: Number(vehicle.targettLat), lng: Number(vehicle.targettLng) },
        { lat: Number(order.startLat), lng: Number(order.startLng) },true
      );
     
      console.log("Gerçek uzaklık servisi ile",vehicle.plate,betweenPlanningDistance,order.orderNo)

    orderDistance = await realRouteDistance(
      { lat: Number(order.startLat), lng: Number(order.startLng) },
      { lat: Number(order.endLat), lng: Number(order.endLng) },true
    );

    let estimatedArrivalMinutes = 0; // Aracın mevcut konumundan 1.işini bitereceği tahmini süre

    if (vehicle?.planning.state > 4) {
      // Aracın mevcut konumundan teslimat noktasına tahmini varış süresi
      estimatedArrivalMinutes =
        (realRouteDistance(
          { lat: Number(vehicle.latitude), lng: Number(vehicle.longitude) },
          { lat: Number(vehicle.targettLat), lng: Number(vehicle.targettLng), },true
        ) /
          TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED  // Ortalama hız
      estimatedArrivalMinutes + TIME_CONSTANTS.UNLOADING_TIME; //Boşaltma tahliyesi eklemesi
    } else if (vehicle?.planning.state < 5) {
      // Aracın mevcut konumundan Önce Yüklemeye oradan teslimat noktasına tahmini varış süresi
      const estimatedFillinglMinutes =
        (realRouteDistance(
          { lat: Number(vehicle.latitude), lng: Number(vehicle.longitude) },
          { lat: Number(vehicle.outpointLat), lng: Number(vehicle.outpointLng) },true
        ) /
          TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED;

      // Aracın mevcut konumundan teslimat noktasına tahmini varış süresi
      const estimatedeliveryMinutes =
        (realRouteDistance(
          { lat: Number(vehicle.latitude), lng: Number(vehicle.longitude) },
          { lat: Number(vehicle.targettLat), lng: Number(vehicle.targettLng) },true
        ) /
          TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED;

      estimatedArrivalMinutes = estimatedFillinglMinutes + estimatedeliveryMinutes + (TIME_CONSTANTS.LOADING_TIME + TIME_CONSTANTS.UNLOADING_TIME) // Yükleme ve boşaltma tahliye süreside eklendi
    }

    // 2.işin teslim süresinden 1. iş  için haracanak süre çıkarılır ve 2. iş için kalan vakit bulunur
    remainingMinuteForSecondOrder = moment(order.deliveryDate).diff(
      moment().add(estimatedArrivalMinutes, "minutes"),
      "minutes"
    );
  }

  if (!Array.isArray(vehicle?.orderNos)) {
    vehicle.orderNos = [];
  }

  // Rezervasyon sisteminden gelen orderNos'ları kullan (daha güncel)
  const reservationOrderNos = vehicle?.allReservations?.map(r => r.orderNo) || [];
  const actualOrderNos = reservationOrderNos.length > 0 ? reservationOrderNos : vehicle.orderNos;


  const result = (
    actualOrderNos.length == 0 ||
    (
      (actualJobCount == 1 && // araçta sadece 1 spot iş olacak (rezervasyondan)
        actualOrderNos.filter((r) => r != order.orderNo).length == 1) && // aracın seçilen siparişten 1 farklı işi olmalı
      (DISTANCE_LIMITS.SEQUENTIAL_MAX_DISTANCE - betweenPlanningDistance >= 0 && // 100 km uzaklığa göre işi bitmek üzere olan araçlar gelebilir.
        remainingMinuteForSecondOrder > //2.sipariş için kalan süre
        ((orderDistance / TIME_CONSTANTS.AVERAGE_SPEED) * TIME_CONSTANTS.AVERAGE_SPEED + (TIME_CONSTANTS.LOADING_TIME + TIME_CONSTANTS.UNLOADING_TIME)))) //2. sipariş için gerekli olan mesafe süresi artı tahliye süresi (30+30)
  );


  return result;
  // Araç üzerinde bir spot iş olabilir.

  //Siparişin teslim tarihinin diğer işin teslim tarihi farkı,
  //Bana lazım olan hedeflenen süreden küçük olmalı.
  //Ve bunu dakika cinsinden hesaplıyoruz.
}


module.exports = {
  isSequential,
  isSequentialWithRealRoute
}